import { useEffect, useState } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

const Countdown = ({ date1, date2 }) => {
	const [remaining, setRemaining] = useState("");

	const dateTime1 = dayjs(`${date1} 09:00`, "DD-MM-YYYY HH:mm");
	const dateTime2 = dayjs(`${date2} 10:00`, "DD-MM-YYYY HH:mm");

	useEffect(() => {
		const updateCountdown = () => {
			const now = dayjs();
			const start = now.isBefore(dateTime1) ? dateTime1 : now;
			const end = dateTime2;
			const diff = end.diff(start);

			if (diff <= 0) {
				setRemaining("La vente est fermé");
				return;
			}

			const d = dayjs.duration(diff);

			const days = Math.floor(d.asDays());
			const hours = d.hours();
			const minutes = d.minutes();
			const seconds = d.seconds();

			const formatted = `${days} J - ${hours}H${String(minutes).padStart(
				2,
				"0"
			)}:${String(seconds).padStart(2, "0")}`;

			setRemaining("Fin dans " + formatted);
		};

		updateCountdown();

		const interval = setInterval(updateCountdown, 1000);
		return () => clearInterval(interval);
	}, [dateTime1, dateTime2]);

	return remaining;
};

export default Countdown;
